import gql from 'graphql-tag'

import { AllWidgetsFragment } from '../../Fragment/Widgets/AllWidgets'

export const ComponentWidgets = gql`
  ${AllWidgetsFragment}

  query ComponentWidgets(
    $name: String!
    $currency: Currency!
    $shippingDestination: Country!
  ) {
    componentWidgets(name: $name) {
      ...AllWidgets
    }
  }
`
